import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { emptySections, emptyIndiaFields } from '../lib/resume';
import { track } from '../lib/analytics';
import { SIGNUP_PATH } from '../lib/marketing';

// Starts a resume from a template: creates it for signed-in users, otherwise routes through signup and back.
export const useStartResume = () => {
  const { user } = useAuth();
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(null);

  const start = useCallback(async (tpl) => {
    track('template_select', { template_id: tpl.id });
    if (!user) { navigate(`${SIGNUP_PATH}&next=${encodeURIComponent(`/templates?use=${tpl.id}`)}`); return; }
    setCreating(tpl.id);
    try {
      const { data } = await api.post('/resumes', {
        title: t('common.untitled'), template_id: tpl.id, language: lang,
        sections: emptySections(),
        india_fields: tpl.id === 'indian' ? { ...emptyIndiaFields(), enabled: true } : emptyIndiaFields(),
      });
      track('builder_start', { template_id: tpl.id });
      track('resume_created', { template_id: tpl.id, source: 'template' });
      navigate(`/builder/${data.resume_id}`);
    } catch (e) {
      toast.error(t('toast.error'));
      setCreating(null);
    }
  }, [user, lang, t, navigate]);

  return { start, creating };
};
